import React, { useRef, useEffect, useState } from "react";

const Whiteboard: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [context, setContext] = useState<CanvasRenderingContext2D | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        // Set background to white
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Set stroke style for drawing
        ctx.strokeStyle = "black";
        ctx.lineWidth = 2;

        setContext(ctx);
      }
    }
  }, []);

  const startDrawing = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (context) {
      setIsDrawing(true);
      const { offsetX, offsetY } = event.nativeEvent;
      context.beginPath();
      context.moveTo(offsetX, offsetY);
    }
  };

  const draw = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (isDrawing && context) {
      const { offsetX, offsetY } = event.nativeEvent;
      context.lineTo(offsetX, offsetY);
      context.stroke();
    }
  };

  const endDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    if (context) {
      // Repaint background white instead of clearing to transparency
      context.fillStyle = "white";
      context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    }
  };

  return (
    <div className="justify-center">
      <canvas
        ref={canvasRef}
        width={260}
        height={450}
        style={{ border: "1px solid #ccc", backgroundColor: "white" }}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={endDrawing}
        onMouseLeave={endDrawing}
      />
      <br />
      <button onClick={clearCanvas}>Clear</button>
    </div>
  );
};

export default Whiteboard;
